import React, { useState, useEffect } from "react";
import { FormRow, FormGroup } from "../../../styles/forms/main";
import { submitObjection, getSectionsList, getItemsList } from "./../api";
import ModalComponent from "./../../../components/modal";
import { setMessage } from "./../../shared/notification/slice";
import TextArea from "./../../../components/textArea";
import { mapObjectOnWorkingConditionToData } from "./../mapToData";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import SelectWithSearch from "./../../../components/selectWithSearch";
import { mapSectionsItemsToUi } from "./../mapToUi";
import trackAnalytics from "../../../trackAnalytics";
import { getUserRoles } from "../../auth/slice";

export default function ObjectionModal({
    isShow,
    activeWorkingCondition,
    conditionId,
    onHide,
    conditionStatus,
}) {
    const [objections, setObjections] = useState({});
    const [sectionsList, setSectionsList] = useState([]);
    const [itemsList, setItemsList] = useState([]);
    const dispatch = useDispatch();
    const getCurrentUserRoles = useSelector(getUserRoles());

    useEffect(() => {
        fetchSections();
    }, []);
    const fetchSections = async () => {
        const data = await getSectionsList();
        setSectionsList(mapSectionsItemsToUi(_.values(data?.entities["sections"]), "id", "name"));
    };

    const fetchItems = async (sectionID) => {
        const data = await getItemsList(sectionID);
        setItemsList(mapSectionsItemsToUi(_.values(data?.entities["items"]), "id", "name"));
    };
    const objectionModalBody = () => {
        return (
            <div>
                <FormRow>
                    <FormGroup>
                        <SelectWithSearch
                            options={sectionsList}
                            value={objections?.section}
                            isEditable={true}
                            name="section"
                            label="Section"
                            required={true}
                            placeholder="Select The Section.."
                            handleChange={(e) => {
                                setObjections({
                                    ...objections,
                                    section: e,
                                    item: {},
                                });
                                fetchItems(e?.value);
                            }}
                        />
                    </FormGroup>
                    <FormGroup>
                        <SelectWithSearch
                            isEditable={true}
                            isMulti={false}
                            label="Item"
                            options={itemsList}
                            handleChange={(e) => {
                                setObjections({
                                    ...objections,
                                    item: e,
                                });
                            }}
                            value={objections?.item}
                            name="item"
                            placeholder="select the item.."
                            required={true}
                            disable={
                                objections?.section?.value === "" ||
                                objections?.section?.value === undefined
                            }
                        />
                    </FormGroup>
                </FormRow>
                <FormRow>
                    <TextArea
                        isEditable={true}
                        type="text"
                        name="objection-reason"
                        onChange={(e) => {
                            setObjections({
                                ...objections,
                                objectionComment: e.target.value,
                            });
                        }}
                        label="Comment"
                        placeholder="write your Comment ....."
                        value={objections?.objectionComment}
                        required={true}
                    />
                </FormRow>
            </div>
        );
    };
    const submitObjections = () => {
        submitObjection(mapObjectOnWorkingConditionToData(objections, conditionId))
            .then(async (res) => {
                dispatch(
                    setMessage({
                        content: `your object submitted successfully `,
                        isError: false,
                    })
                );
                onHide();
                const mixpanelValue = {
                    item: objections?.item?.label,
                    objectionComment: objections?.objectionComment,
                    section: objections?.section?.label,
                };
                if (conditionStatus === "Approved") {
                    trackAnalytics(
                        `${getCurrentUserRoles}_project_object_after_approval`,
                        mixpanelValue
                    );
                } else {
                    trackAnalytics(`${getCurrentUserRoles}_project_object_submit`, mixpanelValue);
                }
                window.location.reload(false);
            })
            .catch((error) => {
                dispatch(
                    setMessage({
                        content: error,
                        title: `Couldn't submit your object  `,
                        isError: true,
                    })
                );
            });
    };
    return (
        <ModalComponent
            open={isShow}
            grow
            key="addLocation"
            submitBtn
            cancelBtn
            submitBtnText="submit"
            header={`Object On Working Condition #${activeWorkingCondition + 1}`}
            onSubmit={() => {
                submitObjections();
            }}
            onClose={(e) => {
                e.preventDefault();
                onHide();
            }}
            closeOnClickOutSide
            isFooter
            size="md"
            disabled={
                objections === undefined ||
                objections?.section === undefined ||
                objections?.section === null ||
                objections?.section?.value === undefined ||
                objections?.item === undefined ||
                objections?.item === null ||
                objections?.item?.value === undefined ||
                objections?.objectionComment === "" ||
                objections?.objectionComment === undefined
            }
        >
            <div>{objectionModalBody()}</div>
        </ModalComponent>
    );
}
